import React from 'react'
import { useHistory, Link } from 'react-router-dom'
import { Descriptions, Space, Button } from 'antd'
import { UserAddOutlined } from '@ant-design/icons'
import {
  employeesListPath,
  createEmployeePath,
  ordersPath,
  transactionsPath,
} from '../../../../../routes/paths'
import { Users } from './Users'

const { Item } = Descriptions
type Props = {
  companyId: string
  employeesCount: number
  ordersCount: number
  transactionsCount: number
}

export const View: React.FunctionComponent<Props> = ({
  companyId,
  employeesCount,
  ordersCount,
  transactionsCount,
}) => {
  const history = useHistory()

  return (
    <Descriptions bordered column={1} labelStyle={{ width: 300 }}>
      <Item label="Количество сотрудников">
        <Space size={20}>
          <Link
            to={{
              pathname: employeesListPath(),
              search: `company=${companyId}`,
            }}
          >
            {employeesCount}
          </Link>
          <Button
            type="primary"
            shape="round"
            icon={<UserAddOutlined />}
            size="small"
            onClick={() => {
              history.push({
                pathname: createEmployeePath(),
                search: `company=${companyId}`,
              })
            }}
          />
        </Space>
      </Item>

      <Item label="Количество заказов">
        <Link
          to={{
            pathname: ordersPath(),
            search: `company=${companyId}`,
          }}
        >
          {ordersCount}
        </Link>
      </Item>

      <Item label="Количество транзакций">
        <Link
          to={{
            pathname: transactionsPath(),
            search: `company=${companyId}`,
          }}
        >
          {transactionsCount}
        </Link>
      </Item>

      <Item label="Администраторы">
        <Users />
      </Item>
    </Descriptions>
  )
}
